import ProgressTrackerFunding from 'features/onboarding/screens/ProgressTrackerFundingScreen/ProgressTrackerFundingScreen';
import React from 'react';
import { PinwheelContextProvider } from 'shared/providers/pinwheel/PinwheelContextProvider/PinwheelContextProvider';

export default function ProgressTrackerFundingPage() {
  return (
    <PinwheelContextProvider>
      <ProgressTrackerFunding />
    </PinwheelContextProvider>
  );
}
